var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "container p-0 pb-10",
    },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "mb-3",
              attrs: {
                cols: "12",
              },
            },
            [
              _c(
                "v-menu",
                {
                  ref: "showDateDialog",
                  attrs: {
                    "close-on-content-click": false,
                    "return-value": _vm.dateSelect,
                    transition: "scale-transition",
                    "offset-y": "",
                    "min-width": "auto",
                  },
                  on: {
                    "update:returnValue": function ($event) {
                      _vm.dateSelect = $event
                    },
                    "update:return-value": function ($event) {
                      _vm.dateSelect = $event
                    },
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function (_ref) {
                        var on = _ref.on,
                          attrs = _ref.attrs
                        return [
                          _c(
                            "v-text-field",
                            _vm._g(
                              _vm._b(
                                {
                                  attrs: {
                                    label: "วันที่",
                                    outlined: "",
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.dateSelectDisplay,
                                    callback: function ($$v) {
                                      _vm.dateSelectDisplay = $$v
                                    },
                                    expression: "dateSelectDisplay",
                                  },
                                },
                                "v-text-field",
                                attrs,
                                false
                              ),
                              on
                            )
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.showDateDialog,
                    callback: function ($$v) {
                      _vm.showDateDialog = $$v
                    },
                    expression: "showDateDialog",
                  },
                },
                [
                  _vm._v(" "),
                  _c("v-date-picker", {
                    attrs: {
                      "no-title": "",
                    },
                    on: {
                      change: function ($event) {
                        _vm.$refs.showDateDialog.save(_vm.dateSelectDisplay)

                        _vm.showDateDialog = false

                        _vm.changeSlug(_vm.slug)
                      },
                    },
                    model: {
                      value: _vm.dateSelect,
                      callback: function ($$v) {
                        _vm.dateSelect = $$v
                      },
                      expression: "dateSelect",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "row mb-3 justify-content-start",
        },
        [
          _c(
            "div",
            {
              staticClass: "col-6 col-sm-3 col-lg-3 col-xl-2 mb-3",
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn text-lg btn-outline-yellow w-100 px-0",
                  class: _vm.classActive("soidown_5"),
                  attrs: {
                    type: "button",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeSlug("soidown_5")
                    },
                  },
                },
                [_vm._v("\n        สอยดาว 5 นาที\n      ")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-6 col-sm-3 col-lg-3 col-xl-2 mb-3",
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn text-lg btn-outline-yellow w-100 px-0",
                  class: _vm.classActive("soidown"),
                  attrs: {
                    type: "button",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeSlug("soidown")
                    },
                  },
                },
                [_vm._v("\n        สอยดาว 10 นาที\n      ")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-6 col-sm-3 col-lg-3 col-xl-2 mb-3",
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn text-lg btn-outline-yellow w-100 px-0",
                  class: _vm.classActive("soidown_15"),
                  attrs: {
                    type: "button",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeSlug("soidown_15")
                    },
                  },
                },
                [_vm._v("\n        สอยดาว 15 นาที\n      ")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-6 col-sm-3 col-lg-3 col-xl-2 mb-3",
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn text-lg btn-outline-success w-100 px-0",
                  class: _vm.classActive("lotto_thai"),
                  attrs: {
                    type: "button",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeSlug("lotto_thai")
                    },
                  },
                },
                [_vm._v("\n        หวยรัฐ / หวยหุ้น\n      ")]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.slug != "lotto_thai"
        ? _c(
            "div",
            {
              staticClass: "row mb-3",
            },
            [
              _c(
                "div",
                {
                  staticClass: "col-6",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn text-lg btn-outline-dark w-100 px-0",
                      class: _vm.typeActive("short"),
                      attrs: {
                        type: "button",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.changeType("short")
                        },
                      },
                    },
                    [_vm._v("\n        มุมมองสั้น\n      ")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-6",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn text-lg btn-outline-dark w-100 px-0",
                      class: _vm.typeActive("long"),
                      attrs: {
                        type: "button",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.changeType("long")
                        },
                      },
                    },
                    [_vm._v("\n        มุมมองยาว\n      ")]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.viewType == "short"
        ? _c(
            "div",
            {
              staticClass: "row mb-3",
            },
            [
              _c(
                "div",
                {
                  staticClass: "col-12 mb-3",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "card-header text-left text-white",
                          class:
                            _vm.slug == "soidown" ||
                            _vm.slug == "soidown_5" ||
                            _vm.slug == "soidown_15"
                              ? "bg-yellow"
                              : _vm.slug == "yeekee_thl_5" ||
                                _vm.slug == "yeekee_thl_15"
                              ? "bg-orange"
                              : _vm.slug == "yeekee_lto_5" ||
                                _vm.slug == "yeekee_lto_15"
                              ? "bg-blue"
                              : _vm.slug == "yeekee_huay_5" ||
                                _vm.slug == "yeekee_huay_15"
                              ? "bg-info"
                              : _vm.slug == "yeekee_chj_5" ||
                                _vm.slug == "yeekee_chj_15"
                              ? "bg-primary"
                              : _vm.slug == "yeekee_dna_5" ||
                                _vm.slug == "yeekee_dna_15"
                              ? "bg-blue-dark"
                              : _vm.slug == "soidown_vip"
                              ? "bg-purple"
                              : "bg-success",
                          attrs: {
                            id: "short_title",
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.roundCurrent) +
                              " " +
                              _vm._s(_vm.gameThaiDate) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "card-body d-flex",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex-width border-right border-gray",
                            },
                            [
                              _c(
                                "h5",
                                {
                                  staticClass: "text-center",
                                },
                                [
                                  _vm._v(
                                    "\n              สามตัวบน\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "h4",
                                {
                                  staticClass: "text-center text-black",
                                  attrs: {
                                    id: "short_result_tripple",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.treeDigitCurrent) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "flex-width",
                            },
                            [
                              _c(
                                "h5",
                                {
                                  staticClass: "text-center",
                                },
                                [
                                  _vm._v(
                                    "\n              สองตัวล่าง\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "h4",
                                {
                                  staticClass: "text-center text-black",
                                  attrs: {
                                    id: "short_result_double",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.twoDigitCurrent) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12",
                },
                _vm._l(_vm.dataRewards, function (reward) {
                  return _c(
                    "div",
                    {
                      key: reward.id,
                      staticClass: "button-result-short",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn-round-short btn btn-outline-dark px-0 py-0 h-100 w-100 mx-0 my-0",
                          class: _vm.buttonActive(reward.id),
                          attrs: {
                            id: reward.id,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeCurrent(
                                reward.master.name + reward.readable_edition,
                                reward.results.length > 1
                                  ? reward.results[0].result_value
                                  : "รอผล",
                                reward.results.length > 1
                                  ? reward.results[1].result_value
                                  : "รอผล"
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.spritRoundName(reward.edition_slug)) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          )
        : _c(
            "div",
            {
              staticClass: "row",
            },
            [
              _vm.slug != "lotto_thai"
                ? _c(
                    "div",
                    {
                      staticClass: "col-12 mb-3",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "card",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "card-header text-left text-white",
                              class:
                                _vm.slug == "soidown" ||
                                _vm.slug == "soidown_5" ||
                                _vm.slug == "soidown_15"
                                  ? "bg-yellow"
                                  : _vm.slug == "yeekee_thl_5" ||
                                    _vm.slug == "yeekee_thl_15"
                                  ? "bg-orange"
                                  : _vm.slug == "yeekee_lto_5" ||
                                    _vm.slug == "yeekee_lto_15"
                                  ? "bg-blue"
                                  : _vm.slug == "yeekee_huay_5" ||
                                    _vm.slug == "yeekee_huay_15"
                                  ? "bg-info"
                                  : _vm.slug == "yeekee_chj_5" ||
                                    _vm.slug == "yeekee_chj_15"
                                  ? "bg-primary"
                                  : _vm.slug == "yeekee_dna_5" ||
                                    _vm.slug == "yeekee_dna_15"
                                  ? "bg-blue-dark"
                                  : _vm.slug == "soidown_vip"
                                  ? "bg-purple"
                                  : "bg-success",
                              attrs: {
                                id: "short_title",
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.roundCurrent) +
                                  " " +
                                  _vm._s(_vm.gameThaiDate) +
                                  "\n        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "card-body d-flex",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex-width border-right border-gray",
                                },
                                [
                                  _c(
                                    "h5",
                                    {
                                      staticClass: "text-center",
                                    },
                                    [
                                      _vm._v(
                                        "\n              สามตัวบน\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "h4",
                                    {
                                      staticClass: "text-center text-black",
                                      attrs: {
                                        id: "short_result_tripple",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.treeDigitCurrent) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "flex-width",
                                },
                                [
                                  _c(
                                    "h5",
                                    {
                                      staticClass: "text-center",
                                    },
                                    [
                                      _vm._v(
                                        "\n              สองตัวล่าง\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "h4",
                                    {
                                      staticClass: "text-center text-black",
                                      attrs: {
                                        id: "short_result_double",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.twoDigitCurrent) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.dataRewards, function (reward) {
                return _vm.idCurrent != reward.id
                  ? _c(
                      "div",
                      {
                        key: reward.id,
                        staticClass: "rounded-lg mb-2",
                        class:
                          reward.master.slug == "lotto_thai" ||
                          reward.master.slug == "lotto_thai2"
                            ? "col-12"
                            : "col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "px-0 py-1 rounded-lg-top",
                            class:
                              reward.master.slug == "lotto_thai" ||
                              reward.master.slug == "lotto_thai2"
                                ? "bg-ktb"
                                : reward.master.slug == "soidown" ||
                                  reward.master.slug == "soidown_5" ||
                                  reward.master.slug == "soidown_15"
                                ? "bg-yellow"
                                : reward.master.slug == "yeekee_thl_5" ||
                                  reward.master.slug == "yeekee_thl_15"
                                ? "bg-orange"
                                : reward.master.slug == "yeekee_lto_5" ||
                                  reward.master.slug == "yeekee_lto_15"
                                ? "bg-blue"
                                : reward.master.slug == "yeekee_huay_5" ||
                                  reward.master.slug == "yeekee_huay_15"
                                ? "bg-info"
                                : reward.master.slug == "yeekee_chj_5" ||
                                  reward.master.slug == "yeekee_chj_15"
                                ? "bg-primary"
                                : reward.master.slug == "yeekee_dna_5" ||
                                  reward.master.slug == "yeekee_dna_15"
                                ? "bg-blue-dark"
                                : reward.master.slug == "lotto_baac"
                                ? "bg-baac"
                                : reward.master.slug == "lotto_gsb"
                                ? "bg-gsb"
                                : "bg-success",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "w-100 text-center text-white text-lg",
                              },
                              [
                                _vm._v(
                                  "\n          " + _vm._s(reward.master.name)
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n          " +
                                    _vm._s(reward.readable_edition) +
                                    "\n          " +
                                    _vm._s(reward.game_thai_date) +
                                    "\n        "
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        reward.master.slug == "lotto_thai" ||
                        reward.master.slug == "lotto_thai2"
                          ? _c(
                              "div",
                              {
                                staticClass: "w-100 px-1",
                              },
                              [
                                reward.results.length > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "border-right border-left border-bottom rounded-bottom py-1",
                                      },
                                      [
                                        _vm._m(0, true),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex w-100 border-bottom mb-3 pb-3",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex-width text-center text-xl",
                                              },
                                              [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      reward.results[0]
                                                        .result_value
                                                    ) +
                                                    "\n            "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._m(1, true),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "d-flex w-100",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex-width text-center text-xl",
                                              },
                                              [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      reward.results[5]
                                                        .result_value
                                                    ) +
                                                    " ,\n              " +
                                                    _vm._s(
                                                      reward.results[4]
                                                        .result_value
                                                    ) +
                                                    "\n            "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex-width text-center text-xl border-left border-right",
                                              },
                                              [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      reward.results[3]
                                                        .result_value
                                                    ) +
                                                    " ,\n              " +
                                                    _vm._s(
                                                      reward.results[2]
                                                        .result_value
                                                    ) +
                                                    "\n            "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex-width text-center text-xl",
                                              },
                                              [
                                                _vm._v(
                                                  "\n              " +
                                                    _vm._s(
                                                      reward.results[1]
                                                        .result_value
                                                    ) +
                                                    "\n            "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticClass:
                                          "border-right border-left border-bottom rounded-bottom py-1",
                                      },
                                      [
                                        _vm._m(2, true),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex w-100 border-bottom mb-3 pb-3",
                                          },
                                          [
                                            reward.status != "cancel"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex-width text-center text-xl",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n              รอผล\n            "
                                                    ),
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex-width text-center text-xl",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n              ยกเลิก\n            "
                                                    ),
                                                  ]
                                                ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._m(3, true),
                                        _vm._v(" "),
                                        reward.status != "cancel"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "d-flex w-100",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex-width text-center text-xl",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n              รอผล\n            "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex-width text-center text-xl border-left border-right",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n              รอผล\n            "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex-width text-center text-xl",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n              รอผล\n            "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass: "d-flex w-100",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex-width text-center text-xl",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n              ยกเลิก\n            "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex-width text-center text-xl border-left border-right",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n              ยกเลิก\n            "
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "flex-width text-center text-xl",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n              ยกเลิก\n            "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                      ]
                                    ),
                              ]
                            )
                          : _c("div", [
                              !reward.master.slug.startsWith("step_")
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex border-left border-right py-1",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-width text-center text-xl text-md",
                                        },
                                        [
                                          _vm._v(
                                            "\n            สองตัวล่าง\n          "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-width text-center text-xl text-md",
                                        },
                                        [
                                          _vm._v(
                                            "\n            สามตัวบน\n          "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex border-left border-right py-1",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-width text-center text-xl text-md",
                                        },
                                        [
                                          _vm._v(
                                            "\n            สี่ตัวบน\n          "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                              _vm._v(" "),
                              reward.results.length > 0
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex border-right border-left border-bottom rounded-bottom py-1",
                                    },
                                    _vm._l(reward.results, function (result) {
                                      return _c(
                                        "div",
                                        {
                                          key: result.result_value,
                                          staticClass:
                                            "flex-width text-center text-xl text-md text-black",
                                        },
                                        [
                                          _vm._v(
                                            "\n            " +
                                              _vm._s(result.result_value) +
                                              "\n          "
                                          ),
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex border-right border-left border-bottom rounded-bottom py-1",
                                    },
                                    [
                                      !reward.master.slug.startsWith("step_")
                                        ? _c(
                                            "span",
                                            {
                                              staticClass: "w-100 d-flex",
                                            },
                                            [
                                              reward.status != "cancel"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex-width text-center text-xl text-md text-primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n              รอผล\n            "
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex-width text-center text-xl text-md text-primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n              ยกเลิก\n            "
                                                      ),
                                                    ]
                                                  ),
                                              _vm._v(" "),
                                              reward.status != "cancel"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex-width text-center text-xl text-md text-primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n              รอผล\n            "
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex-width text-center text-xl text-md text-primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n              ยกเลิก\n            "
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          )
                                        : _c(
                                            "span",
                                            {
                                              staticClass: "w-100 d-flex",
                                            },
                                            [
                                              reward.status != "cancel"
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex-width text-center text-xl text-md text-primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n              รอผล\n            "
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex-width text-center text-xl text-md text-primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n              ยกเลิก\n            "
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          ),
                                    ]
                                  ),
                            ]),
                      ]
                    )
                  : _vm._e()
              }),
            ],
            2
          ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "d-flex w-100",
      },
      [
        _c(
          "div",
          {
            staticClass: "flex-width text-center text-xl",
          },
          [
            _c(
              "small",
              {
                staticClass: "text-md",
              },
              [_vm._v("รางวัลที่ 1")]
            ),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "d-flex w-100",
      },
      [
        _c(
          "div",
          {
            staticClass: "flex-width text-center text-xl",
          },
          [
            _c(
              "small",
              {
                staticClass: "text-md",
              },
              [_vm._v("สามตัวหน้า")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "flex-width text-center text-xl border-left border-right",
          },
          [
            _c(
              "small",
              {
                staticClass: "text-md",
              },
              [_vm._v("สามตัวหลัง")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex-width text-center text-xl",
          },
          [
            _c(
              "small",
              {
                staticClass: "text-md",
              },
              [_vm._v("2ตัวล่าง")]
            ),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "d-flex w-100",
      },
      [
        _c(
          "div",
          {
            staticClass: "flex-width text-center text-xl",
          },
          [
            _c(
              "small",
              {
                staticClass: "text-md",
              },
              [_vm._v("รางวัลที่ 1")]
            ),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "d-flex w-100",
      },
      [
        _c(
          "div",
          {
            staticClass: "flex-width text-center text-xl",
          },
          [
            _c(
              "small",
              {
                staticClass: "text-md",
              },
              [_vm._v("สามตัวหน้า")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "flex-width text-center text-xl border-left border-right",
          },
          [
            _c(
              "small",
              {
                staticClass: "text-md",
              },
              [_vm._v("สามตัวหลัง")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex-width text-center text-xl",
          },
          [
            _c(
              "small",
              {
                staticClass: "text-md",
              },
              [_vm._v("2ตัวล่าง")]
            ),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }